/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import RelationshipBaseRequestHandler from './RelationshipBaseRequestHandler';
import { getAllFieldNodesFromDiagramCache, addFields } from 'components/startingPoints/relationshipGraph/RelationshipUtil.js';
import StringResources from 'nls/StringResources';

/**
 *
 * This class handles scoping related request, such as addedField, Scoped Fields
 *
 * @extends RelationshipBaseRequestHandler
 */
class RelationshipScopeRequestHandler extends RelationshipBaseRequestHandler {

	/*Add query parameters based on the context*/
	static _addQueryParams(querySpec, context){
		// Add common parameters for all cases first
		return super._addQueryParams(querySpec, context)
			.then(() => {
				let fields = [];
				const lastAddedFields = context.transformOptions.lastAddedFields;
				const scopedFields = context.transformOptions.scopedFields;
				if(lastAddedFields) {
					const rawData = context.rawData;
					if(rawData) {
						fields = getAllFieldNodesFromDiagramCache(rawData, true /*exclude focus field*/) || [];
						lastAddedFields.forEach((field) => {
							if(fields.indexOf(field) === -1 ){
								fields.push(field);
							}
						});
					}
				} else if (scopedFields) {
					fields = scopedFields;
				}
				querySpec.exploreAnalysisScope = JSON.stringify({ inScopeTables:context.targetModel.buildScopedFields(fields) });
			});
	}

	/**
	 * @Overriden RelationshipBaseRequestHandler._callback
	 * TODO: verify if this function is really needed
	 */
	static _callback(response, context){
		const lastAddedFields = context.transformOptions.lastAddedFields;
		if(lastAddedFields){
			const result = addFields(context.diagramData, response, { addedFields: lastAddedFields, targetId: context.model.getCurrentTargetId(), showPrimaryRelationshipView: true });
			if(result && result.unfoundNodeIds.length) {
				context.targetModel.setActionInfoStatus(StringResources.get('startingPoints_no_direct_relationship',  { columndIDAndLabel: JSON.stringify(result.unfoundNodeIds) }));
			}
		}
	}
}

export default RelationshipScopeRequestHandler;



// WEBPACK FOOTER //
// ./src/js/util/RelationshipScopeRequestHandler.js